export const BUILDING_YEARS = [2024, 2025];
export const DEFAULT_BUILDING_YEAR = 2025;

export function parseBuildingYear(value, fallback = DEFAULT_BUILDING_YEAR) {
    const year = Number(value);
    return BUILDING_YEARS.includes(year) ? year : fallback;
}

export function yearQuery(year) {
    const parsed = Number(year);
    return BUILDING_YEARS.includes(parsed) ? { year: parsed } : {};
}
